import { render, staticRenderFns } from "./ProjectSettings.vue?vue&type=template&id=6cc2cec0&scoped=true&"
import script from "./ProjectSettings.vue?vue&type=script&lang=js&"
export * from "./ProjectSettings.vue?vue&type=script&lang=js&"
import style0 from "./ProjectSettings.vue?vue&type=style&index=0&id=6cc2cec0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cc2cec0",
  null
  
)

export default component.exports